<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="prose-sm w-full" v-html="renderedContent" />
</template>

<script setup lang="ts">
import { computedAsync } from "@vueuse/core"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeStringify from "rehype-stringify"
import rehypeSanitize from "rehype-sanitize"

const props = defineProps<{
  content: string
}>()

const renderedContent = computedAsync(
  async () =>
    await unified()
      .use(remarkParse)
      .use(remarkRehype)
      .use(rehypeSanitize)
      .use(rehypeStringify)
      .process(props.content)
)
</script>
